var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableWithPagination',{attrs:{"tableData":_vm.targetLists,"max-height":"400px","columnList":_vm.columnList}})
}
var staticRenderFns = []

export { render, staticRenderFns }